import { useEffect } from 'react';
import mixpanel, { trackedEvents } from 'app/utils/mixpanel';
import mParticle from 'app/utils/mparticle';
import { useRouter } from 'next/router';

const usePageViewTracker = () => {
  const router = useRouter();
  useEffect(() => {
    mixpanel.track(trackedEvents.PageView);
    mParticle.logPageView(router.asPath, { ...router.query });
  }, []);
};

export default usePageViewTracker;
